import styled from 'styled-components'

export const GeneralInformationCompare = styled.div`
  margin-top: 10px;
  max-width: 590px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  width: 100%;
  background: ${ (props) => props.theme.colors.weiss };

  &.noMarginTop {
    margin-top: 0;
  }

  &.mobile {
    max-width: inherit;
    padding: 0 5px;
  }

  .item-header {
    position: relative;
    font-weight: 300;
    line-height: 1.39em;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      height: 100%;
    }

    h2 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow-x: hidden;
      width: 90%;
    }

    color: ${ (props) => props.theme.colors['icon-grau1'] };
    border-bottom: 1px solid
      ${ (props) => props.theme.colors['divider-detail-link-list'] };
    padding: 10px 20px 5px 20px;

    @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
      border-bottom: 0;
      padding: 13px 18px 20px 20px;
    }

    &.no-padding {
      padding-bottom: 0;
    }

    .cooperation {
      font-size: 16px;
      margin-bottom: 5px;
    }

    .headline-alternative {
      font-size: 24px;
      line-height: 1.21em;
      margin-top: 3px;
      margin-bottom: 20px;

      &.has-subjectArea {
        margin-bottom: 5px;
      }
    }

    .specification {
      margin-bottom: 10px;
    }

    .bookmark-general-information {
      position: absolute;
      top: 10px;
      right: 0;

      &.mobile {
        right: 0;
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
        top: 5px;
        right: 12px;
      }
    }

    p.address {
      display: flex;
      flex-direction: row;

      .address-split {
        display: flex;
        flex-direction: column;
      }
    }
  }

  // dynamic compare data elements
  .data-container {
    padding: 11px 0;
    //height: 100%;
  }

  // contact information part
  .contact-information {
    position: relative;
    font-size: 18px;
    line-height: 1.39em;
    background: ${ (props) => props.theme.colors['hintergrund-prio2'] };

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      height: 100%;
    }

    &.standard {
      padding: 9px 20px 20px 20px;
    }

    &.hospitals {
      padding: 18px 20px 9px 20px;
    }

    .address {
      display: flex;
      flex-direction: row;

      .address-split {
        display: flex;
        flex-direction: column;
      }
    }

    .phone {
      text-decoration: none;
    }

    > p {
      margin-bottom: 10px;
    }
  }
`

export const ContactIcon = styled.span`
  color: ${ (props) => props.theme.colors['icon-grau1'] };
  margin-right: 20px;
`
